import React from 'react';
import VPOPCampaignInputs from './VPOPCampaignInputs';
import TailwindButtonDynamic from '../Layout/TailwindComponents/TailwindButtonDynamic';
import utils from '../../utils';

function VPOPCampaignProgram({ baselineData, optimizedData, addCampaignRow, removeCampaignRow, yearsToShow, productOptions, campaignTypeOptions, handleCampaignOptimization }) {


    const addBtnContent = {
        name: 'Add a campaign',
        icon: utils.getIcon('plus', 'svg-12 m-i-start vertical-align'),
    }

return (
    <div className='p-06 bg-[var(--surface-secondary-light)] border border-[var(--border-secondary-light)] rounded-[var(--border-corner-radius-rounding-03)] mt-04'>
        <label className='label-large block'>Campaign</label>
        
        {baselineData && baselineData.campaign_years && baselineData.campaign_years.length > 0 && (
            <>
                <label className='label-medium block mb-04'>Baseline Campaign (Included in Current Budget):</label>
                {baselineData.campaign_years.map((year, index) => (
                    <VPOPCampaignInputs key={index} disabled={true} year={year} />
                ))}
            </>
        )}

        {optimizedData && optimizedData.campaign_years && optimizedData.campaign_years.length > 0 && (
            <>
                <label className='label-medium block mb-04'>Optimized Campaign:</label>
                {optimizedData.campaign_years.map((year, index) => (
                    <VPOPCampaignInputs
                        key={index}
                        disabled={false}
                        year={year}
                        index={index}
                        removeCampaignRow={removeCampaignRow}
                        yearsToShow={yearsToShow}
                        productOptions={productOptions}
                        campaignTypeOptions={campaignTypeOptions}
                        handleCampaignOptimization={(e) => handleCampaignOptimization(index, e, optimizedData)}
                    />
                ))}
            </>
        )}

        <div className="flex justify-end">
            <TailwindButtonDynamic variant='primarySmallSurfaceBrandSecondary' idName="add-new-campaign" content={addBtnContent} loading={false} actionHandler={() => addCampaignRow()} />
        </div>
    </div>
)
}

export default VPOPCampaignProgram